module.exports = [{"image":"/images/videos/html.jpg","name":"Introduction to HTML","description":"HTML is the standard markup language for creating Web pages.","link":"#"},{"image":"/images/videos/javascript.jpg","name":"Introduction to JavaScript","description":"JavaScript is the programming language of HTML and the Web.","link":"#"}]


//////////////////
// WEBPACK FOOTER
// ./src/utils/videos.json
// module id = 79
// module chunks = 0